import {
  FETCH_ORDERS_RES,
  RECEIVE_WS_ORDERS,
  UPDATE_ORDER_COMPLETED_TIME,
  UPDATE_ORDER_DELIVERED_TIME,
} from '../actions/types';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_ORDERS_RES:
    case RECEIVE_WS_ORDERS:
      let hasChanges = false;
      const newState = { ...state };

      for (let order of action.payload) {
        const existingOrder = state[order._id];

        // New order or line items changed — expand
        if (
          !existingOrder ||
          !existingOrder.line_items ||
          existingOrder.line_items.length !== order.line_items.length
        ) {
          hasChanges = true;
          const expandedItems = [];

          for (let item of order.line_items) {
            const quantity = Number(item.quantity || 1);
            for (let i = 0; i < quantity; i++) {
              const { quantity: _, ...rest } = item;
              expandedItems.push(rest);
            }
          }

          newState[order._id] = { ...order, line_items: expandedItems };
        } else if (
          existingOrder.completed_at !== order.completed_at ||
          existingOrder.delivered_at !== order.delivered_at
        ) {
          // Status changed — update but reuse line items
          hasChanges = true;
          newState[order._id] = {
            ...order,
            line_items: existingOrder.line_items,
          };
        }
        // Otherwise: data unchanged, skip — keep existing reference
      }

      return hasChanges ? newState : state;
    case UPDATE_ORDER_COMPLETED_TIME: {
      const { _id, completed_at } = action.payload;
      return { ...state, [_id]: { ...state[_id], completed_at } };
    }
    case UPDATE_ORDER_DELIVERED_TIME: {
      const { _id, delivered_at } = action.payload;
      return { ...state, [_id]: { ...state[_id], delivered_at } };
    }
    default:
      return state;
  }
}
